"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyButton = void 0;
var classnames_1 = __importDefault(require("classnames"));
var clipboard_1 = __importDefault(require("clipboard"));
var react_1 = __importStar(require("react"));
require("./DownloadButton.scss");
var utils_1 = require("@app/shared/utils");
var CopyButton = function (props) {
    var _a = react_1.useState(false), copySuccess = _a[0], updateSuccess = _a[1];
    var clipboard = new clipboard_1.default("#" + props.copyId, {
        text: function () {
            return props.onCopy();
        }
    });
    var message = copySuccess ? 'Copied' : "Copy" + (props.subject === '' ? '' : " " + props.subject);
    // Clipboard Success event
    clipboard.on('success', function (e) {
        updateSuccess(true);
    });
    // Clipboard Error event
    clipboard.on('error', function (e) {
        updateSuccess(false);
    });
    return (react_1.default.createElement("a", { id: props.copyId, onClick: utils_1.unclickable },
        react_1.default.createElement("div", { className: classnames_1.default('copy-button', { tooltip: props.showTooltip }, props.tooltipPosition), "data-tooltip": message, style: { lineHeight: '1rem' } },
            react_1.default.createElement("i", { className: classnames_1.default('fas', { 'fa-clipboard': !copySuccess }, { 'fa-clipboard-check': copySuccess }) }),
            !props.showTooltip &&
                react_1.default.createElement("p", null, message))));
};
exports.CopyButton = CopyButton;
